import { Injectable } from '@angular/core';
import { LazyService } from './lazy.service';

@Injectable({
  providedIn: 'root', // Ensures the service is a singleton
})
export class ModelCacheService {
  private model: any = null;

  constructor(private lazyService: LazyService) {}

  async loadBlazeFaceModel(): Promise<any> {
    if (this.model) {
      // Return cached model if already loaded
      console.log('Using cached BlazeFace model');
      return this.model;
    }

    try {
      await this.lazyService.loadScript("/assets/js/tensorflow/tfjs.js")
      await this.lazyService.loadScript("/assets/js/tensorflow/blazeface.js")
      console.log('Loading BlazeFace model...');
      this.model = await (window as any).blazeface.load({ maxFaces: 1 });
      console.log('BlazeFace model loaded and cached');
      return this.model;
    } catch (error) {
      console.error('Error loading BlazeFace model:', error);
      throw new Error('Failed to load BlazeFace model');
    }
  }
}
